import { useState, type FormEvent } from "react";
import { ClarifyForm } from "./ClarifyForm";
import { useCapture, useClarify, useInbox, useTrashStuff } from "./hooks";
import { formatAge } from "./format";

export function InboxView() {
  const { data, isLoading, error } = useInbox();
  const capture = useCapture();
  const clarify = useClarify();
  const trash = useTrashStuff();
  const [text, setText] = useState("");
  const [openId, setOpenId] = useState<string | null>(null);

  function onCapture(event: FormEvent) {
    event.preventDefault();
    const value = text.trim();
    if (!value) return;
    capture.mutate(value, { onSuccess: () => setText("") });
  }

  return (
    <div className="view">
      <form className="capture" onSubmit={onCapture}>
        <input
          className="capture__input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Wrzuć do inboxu…"
          aria-label="Wrzuć do inboxu"
        />
        <button className="btn btn--primary" type="submit" disabled={!text.trim() || capture.isPending}>
          Wrzuć
        </button>
      </form>

      {capture.data?.queued && (
        <p className="muted">Brak sieci — zapisane offline, wyślę po jej odzyskaniu.</p>
      )}
      {capture.error && <p className="error">Nie udało się wrzucić do inboxu.</p>}

      {isLoading && <p className="muted">Ładowanie…</p>}
      {error && <p className="error">Nie udało się pobrać inboxu.</p>}
      {data && data.items.length === 0 && <p className="muted">Inbox pusty. 🎉</p>}

      <ul className="rows">
        {data?.items.map(({ stuff, age_hours }) => (
          <li key={stuff.id} className="row">
            <div className="row__main">
              <span className="row__title">{stuff.raw_text}</span>
              <span className="row__meta">
                {formatAge(age_hours)}
                {age_hours >= 48 && <span className="badge badge--warn">stare</span>}
              </span>
            </div>
            <div className="row__actions">
              <button
                className="btn btn--small"
                onClick={() => setOpenId(openId === stuff.id ? null : stuff.id)}
              >
                {openId === stuff.id ? "Zwiń" : "Clarify"}
              </button>
              <button
                className="btn btn--small btn--danger"
                title="Do kosza"
                onClick={() => trash.mutate(stuff.id)}
              >
                🗑
              </button>
            </div>
            {openId === stuff.id && (
              <ClarifyForm
                rawText={stuff.raw_text}
                busy={clarify.isPending}
                onCancel={() => setOpenId(null)}
                onSubmit={(decision) =>
                  clarify.mutate(
                    { stuffId: stuff.id, decision },
                    { onSuccess: () => setOpenId(null) },
                  )
                }
              />
            )}
          </li>
        ))}
      </ul>

      {clarify.error && <p className="error">{(clarify.error as Error).message}</p>}
    </div>
  );
}
